import { render, staticRenderFns } from "./NicheExercised.vue?vue&type=template&id=1b679490&"
import script from "./NicheExercised.vue?vue&type=script&lang=js&"
export * from "./NicheExercised.vue?vue&type=script&lang=js&"
import style0 from "./NicheExercised.vue?vue&type=style&index=0&id=1b679490&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports